<template>
  <div>
    <div v-if="this.DrugNoneData">
      <b-alert show variant="dark" class="margin-bottom font12px">
        <h6>Trx Order</h6>
        <b-row class="margin-bottom">
          <b-col lg="6">
            <b-alert
              variant="secondary"
              show
              v-for="(item, index) in this.Pag1Data"
              v-bind:key="item.id"
              class="margin-bottom2px"
            >
              <div>
                <b-row>
                  <b-col>
                    <div class="pj_clearfix">
                      <div style="float: left;">
                        {{ index + 1 }}.
                        <div
                          :title="
                            'ห้องยาบันทึกจ่ายยาแล้ว \n' +
                              pjFunctionsFc.NulltoStr(
                                item.datas.pay_staff_name
                              ) +
                              ' \nLog. ' +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.pay_datetime
                              )
                          "
                          class="float-left"
                          v-if="item.datas.pay_staff_status == 'Y'"
                        >
                          <v-icon
                            name="check-circle"
                            class="icon-pay-check-read"
                          ></v-icon>
                        </div>
                        {{ item.datas.drugNondugFullName }}
                      </div>
                      <div class="float-right">
                        <strong
                          class="font-color-primary"
                          v-if="item.datas.paidst == '02' || !item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                        <strong
                          class="font-color-danger"
                          v-if="item.datas.paidst != '02' && item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                      </div>
                    </div>
                    <div
                      class="pj_clearfix"
                      v-if="
                        item.datas.drug_usage_full &&
                          (item.datas.drug_usage_ename == null ||
                            item.datas.drug_usage_ename == '' ||
                            item.datas.drug_usage_ename == 'null')
                      "
                    >
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_full }}
                    </div>
                    <div class="pj_clearfix" v-if="item.datas.drug_usage_ename">
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_ename }}
                    </div>
                    <div
                      class="pj_clearfix log-style"
                      v-if="item.datas.doctor_name"
                    >
                      {{
                        "&nbsp;&nbsp; Order." +
                          pjFunctionsFc.NulltoStr(item.datas.doctor_name) +
                          " | " +
                          thaiDatetimeFc.ThaiDateTime(
                            item.datas.rxdate + " " + item.datas.rxtime
                          )
                      }}
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <v-icon
                      name="plus-square"
                      class="icon-custom1 cursor-pointer"
                      v-bind:class="{
                        'icon-success': item.datas.items_note_text
                      }"
                      v-b-toggle="'Tg' + item.datas.hos_guid"
                    ></v-icon>
                  </b-col>
                </b-row>
                <b-collapse
                  :id="'Tg' + item.datas.hos_guid"
                  :visible="item.datas.items_note_text && true"
                >
                  <b-form :id="'rxForm' + item.datas.hos_guid">
                    <b-row>
                      <b-col>
                        <input
                          type="hidden"
                          :value="item.datas.icode"
                          :id="'icodeNote' + item.datas.hos_guid"
                        />
                        <b-form-textarea
                          :id="'rxNoteta' + item.datas.hos_guid"
                          size="sm"
                          max-rows="5"
                          :value="
                            pjFunctionsFc.NulltoStr(item.datas.items_note_text)
                          "
                        >
                        </b-form-textarea>
                        <div
                          class="pj_clearfix log-style"
                          v-if="item.datas.items_note_user"
                        >
                          {{
                            "&nbsp;&nbsp; Log." +
                              pjFunctionsFc.NulltoStr(
                                item.datas.items_note_user
                              ) +
                              " | " +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.items_note_datetime
                              )
                          }}
                        </div>
                      </b-col>
                      <b-col cols="1">
                        <b-button
                          @click="rxNoteSubmit(item.datas.hos_guid)"
                          variant="link"
                          style="padding:0px;"
                        >
                          <v-icon
                            name="save"
                            class="icon-custom1 icon-primary cursor-pointer"
                            style="margin-top:100%;"
                          ></v-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-collapse>
              </div>
            </b-alert>
          </b-col>
          <b-col lg="6">
            <b-alert
              variant="secondary"
              show
              v-for="(item, index) in this.Pag2Data"
              v-bind:key="item.id"
              class="margin-bottom2px"
            >
              <div>
                <b-row>
                  <b-col>
                    <div class="pj_clearfix">
                      <div style="float: left;">
                        {{ index + Pag2Start + 1 }}.
                        <div
                          :title="
                            'ห้องยาบันทึกจ่ายยาแล้ว \n' +
                              pjFunctionsFc.NulltoStr(
                                item.datas.pay_staff_name
                              ) +
                              ' \nLog. ' +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.pay_datetime
                              )
                          "
                          class="float-left"
                          v-if="item.datas.pay_staff_status == 'Y'"
                        >
                          <v-icon
                            name="check-circle"
                            class="icon-pay-check-read"
                          ></v-icon>
                        </div>
                        {{ item.datas.drugNondugFullName }}
                      </div>
                      <div class="float-right">
                        <strong
                          class="font-color-primary"
                          v-if="item.datas.paidst == '02' || !item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                        <strong
                          class="font-color-danger"
                          v-if="item.datas.paidst != '02' && item.datas.paidst"
                        >
                          &#3647;
                          {{
                            pjFunctionsFc.Float2Decimal(
                              pjFunctionsFc.strToFloat(item.datas.sum_price)
                            )
                          }}
                        </strong>
                      </div>
                    </div>
                    <div
                      class="pj_clearfix"
                      v-if="
                        item.datas.drug_usage_full &&
                          (item.datas.drug_usage_ename == null ||
                            item.datas.drug_usage_ename == '' ||
                            item.datas.drug_usage_ename == 'null')
                      "
                    >
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_full }}
                    </div>
                    <div class="pj_clearfix" v-if="item.datas.drug_usage_ename">
                      {{ "&nbsp;&nbsp;" + item.datas.drug_usage_ename }}
                    </div>
                    <div
                      class="pj_clearfix log-style"
                      v-if="item.datas.doctor_name"
                    >
                      {{
                        "&nbsp;&nbsp; Order." +
                          pjFunctionsFc.NulltoStr(item.datas.doctor_name) +
                          " | " +
                          thaiDatetimeFc.ThaiDateTime(
                            item.datas.rxdate + " " + item.datas.rxtime
                          )
                      }}
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <v-icon
                      name="plus-square"
                      class="icon-custom1 cursor-pointer"
                      v-bind:class="{
                        'icon-success': item.datas.items_note_text
                      }"
                      v-b-toggle="'Tg' + item.datas.hos_guid"
                    ></v-icon>
                  </b-col>
                </b-row>
                <b-collapse
                  :id="'Tg' + item.datas.hos_guid"
                  :visible="item.datas.items_note_text && true"
                >
                  <b-form :id="'rxForm' + item.datas.hos_guid">
                    <b-row>
                      <b-col>
                        <input
                          type="hidden"
                          :value="item.datas.icode"
                          :id="'icodeNote' + item.datas.hos_guid"
                        />
                        <b-form-textarea
                          :id="'rxNoteta' + item.datas.hos_guid"
                          size="sm"
                          max-rows="5"
                          :value="
                            pjFunctionsFc.NulltoStr(item.datas.items_note_text)
                          "
                        >
                        </b-form-textarea>
                        <div
                          class="pj_clearfix log-style"
                          v-if="item.datas.items_note_user"
                        >
                          {{
                            "&nbsp;&nbsp; Log." +
                              pjFunctionsFc.NulltoStr(
                                item.datas.items_note_user
                              ) +
                              " | " +
                              thaiDatetimeFc.ThaiDateTime(
                                item.datas.items_note_datetime
                              )
                          }}
                        </div>
                      </b-col>
                      <b-col cols="1">
                        <b-button
                          @click="rxNoteSubmit(item.datas.hos_guid)"
                          variant="link"
                          style="padding:0px;"
                        >
                          <v-icon
                            name="save"
                            class="icon-custom1 icon-primary cursor-pointer"
                            style="margin-top:100%;"
                          ></v-icon>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-collapse>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-alert>
    </div>

    <!-- CSS animation example -->
    <notifications
      group="drug-nonedrug-trx-foo-css"
      position="top right"
      animation-name="v-fade-left"
      :speed="500"
    >
    </notifications>

    <!-- Custom template example -->
    <notifications
      group="drug-nonedrug-trx-custom-save"
      :speed="500"
      animation-name="v-fade-left"
      position="bottom right"
    >
      <template slot="body" slot-scope="props">
        <div class="drug-nonedrug-trx-custom-save">
          <div
            class="notification-wrapper cursor-pointer"
            style="transition-timing-function: ease; transition-delay: 0s; transition-property: all;"
            @click="props.close"
          >
            <div class="vue-notification-template vue-notification">
              <div class="notification-title">{{ props.item.title }}</div>
              <div class="custom-template-text" v-html="props.item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientDrugNoneDrug from "@/models/patientEMRs/PatientDrugNoneDrug";

import Notifications from "vue-notification";

Vue.use(feather, "v-icon");
Vue.use(Notifications);

@Component({
  data() {
    return {
      anStart: "",
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      DrugNoneData: null,
      apiCk: 0,
      Pag1Limit: 0,
      Pag2Start: 0,
      Pag1Data: null,
      Pag2Data: null,
      showCollapse: true,
      ptHN: "",
      ptVN: "",
      ptAN: "",
      DataCh: "",
      id: 0,
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2]
        },
        leave: {
          opacity: 0,
          height: 0
        }
      }
    };
  },
  props: ["MyVn", "MyHn", "MyAn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientDrugNoneDrug
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.anChang;
  },
  watch: {
    ptHN: function() {
      // this.setDrugNoneDrugData(this.ptVN, this.ptHN, this.ptAN);
    },
    ptVN: function() {
      this.setDrugNoneDrugData(this.ptVN, this.ptHN, this.ptAN);
    },
    ptAN: function() {
      this.setDrugNoneDrugData(this.ptVN, this.ptHN, this.ptAN);
    },
    DataCh: function() {
      this.getDrugNoneDrugData(this.ptVN, this.ptHN, this.ptAN);
    },
    MyAn: function() {
      if (this.MyAn != "" && this.MyAn != null) {
        this.anChang;
      }
    }
  },
  computed: {
    anChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.ptAN = this.MyAn;

      // console.log('zzzz', this.MyAn, ' | ',this.$store.get('systems@anEMR'), ' | ' ,this.ptAN)

      /*
        if(this.anStart != this.$store.get('systems@anEMR')){
          this.apiCk = 0
          this.anStart = this.$store.get('systems@anEMR')
        }

        if((this.apiCk <= 0 && this.DrugNoneData != null) || (this.DrugNoneData == null && this.apiCk <= 0)){

          this.setDrugNoneDrugData(this.$store.get('systems@anEMR')) 

        }

        this.getDrugNoneDrugData(this.$store.get('systems@anEMR')) */
    }
  },
  methods: {
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    rxNoteSubmit(rxNoteId) {
      let rxNoteForm = document.getElementById("rxForm" + rxNoteId);
      let rxNoteText = rxNoteForm["rxNoteta" + rxNoteId].value;
      let rxIcode = rxNoteForm["icodeNote" + rxNoteId].value;

      if (rxIcode != "" && rxNoteId != "") {
        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DrugNonDrugNoteAdd", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: ScrObj.ptHN,
            vn: ScrObj.ptVN,
            hos_guid: rxNoteId,
            icode: rxIcode,
            rx_note_text: rxNoteText
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              ScrObj.show(
                "drug-nonedrug-trx-foo-css",
                "success",
                "Save Data Success",
                "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );
            } else {
              ScrObj.show(
                "drug-nonedrug-trx-foo-css",
                "warn",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output.ErrorMessage +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
            }
          })
          .catch(function(error) {
            ScrObj.output = error;

            ScrObj.show(
              "drug-nonedrug-trx-foo-css",
              "error",
              "Save Data Error",
              "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                "<br>ErrorMessage : " +
                ScrObj.output +
                "<br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );

            console.log("DrugNonDrugNoteAdd : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.setDrugNoneDrugData(ScrObj.ptVN, ScrObj.ptHN);
          });
      }
    },
    setDrugNoneDrugData: function(vn, hn, an) {
      this.DataCh = "StartDrugNonDrugTrxData" + vn;

      if (an != "" && an != null) {
        this.DrugNoneData = null;

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DrugNonDrugData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an,
            order_type: "Trx"
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientDrugNoneDrug.delete({
                where(record) {
                  return record.an == an;
                }
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.hos_guid,
                  hn: val.hn,
                  vn: val.vn,
                  an: val.an,
                  datas: val
                });
              }

              PatientDrugNoneDrug.insertOrUpdate({
                data
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientDrugNoneDrug.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("DrugNonDrugTrxData : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.DataCh = "DrugNonDrugTrxData" + an;
            ScrObj.getDrugNoneDrugData(ScrObj.ptVN, ScrObj.ptHN, ScrObj.ptAN);
          });
      }
    },
    getDrugNoneDrugData(vn, hn, an) {
      let ScrObj = PatientDrugNoneDrug.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.an == an)
        .where(record => record.datas.order_type == "TRx")
        .get();

      this.Pag1Limit = Math.ceil(ScrObj.length / 2);
      this.Pag2Start = Math.ceil(ScrObj.length / 2);

      if (ScrObj.length > 0) {
        let P1 = [];
        let P2 = [];

        for (let i = 0; i < this.Pag1Limit; i++) {
          P1.push(ScrObj[i]);
        }

        for (let i2 = this.Pag2Start; i2 < ScrObj.length; i2++) {
          P2.push(ScrObj[i2]);
        }

        this.Pag1Data = P1;
        this.Pag2Data = P2;

        this.DrugNoneData = ScrObj[0];
        this.apiCk = this.apiCk + 1;
      } else {
        this.DrugNoneData = null;
        this.Pag1Data = null;
        this.Pag2Data = null;
        this.apiCk = this.apiCk + 1;
      }
    },
    delDrugNoneDrugData(an) {
      PatientDrugNoneDrug.delete({
        where(record) {
          return record.an == an;
        }
      });
    }
  }
})
export default class EmrDrugNoneDrugTrx extends Vue {}
</script>

<style lang="scss">
.icon-pay-check-read {
  margin-top: -2px;
  width: 14px;
  color: red !important;
}
</style>

